const EMPLOYMENT_STATUS_ENUM = {
    EMPLOYED_FULL_TIME: 1,
    EMPLOYED_PART_TIME: 2,
    EMPLOYED_SELF_EMPLOYED: 3,
    EMPLOYED_ARMED_FORCES: 4,
    NOT_EMPLOYED: 5,
    RETIRED: 6,
    AGENCY_WORKER: 7,
    CONTRACT_WORKER: 8,
    SUB_CONTRACTOR: 9,
    DISABILITY: 10,
    HOUSEWIFE: 11,
    STUDENT: 12,
    CARER: 13,
    CARER_NON_PROFESSIONAL: 14
};

module.exports = {
    EMPLOYMENT_STATUS_ENUM
};